const defaultLang = 'de'

module.exports = { defaultLang }
